import { useContext } from 'react';

import { ExperimentalDesignSystemContext } from '../../contexts/experimental-design-system';

/**
 * Whether the experimental design-system *button colour* rework is active for the
 * tones still held behind it — the success family (`success`, `success_ghost`,
 * `codes`) on the reworked `semantic-*` / `button-background-*` tokens. The
 * destructive family moved to the forms flag in DS-1567.
 *
 * Value is supplied by `DesignSystemProvider` (`src/providers/design-system-provider.tsx`),
 * which sources it from the Flagsmith `release-experimental-design-system-buttons` flag.
 *
 * This returns the raw flag value. The colour rework only takes visual effect
 * inside the forms-experimental button, so consumers must gate on
 * `isExperimentalForms && isExperimentalButtons` (see `button.tsx`).
 */
export function useIsExperimentalDesignSystemButtons(): boolean {
  return useContext(ExperimentalDesignSystemContext).isExperimentalButtons ?? false;
}
